module.exports = __webpack_public_path__ + "assets/img/1005.97546d77.png";